import React, { useEffect, useState } from 'react';
import * as Images from '../../../assets';
import Loader from '../../ReusableComp/Loader';
import { fetchWithFormDataWithoutBody } from '../../../apiGeneralFunction';

const TCContentDynamic = () => {
    const [tcData, setTcData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchTermsCondition();
    }, []);

    const fetchTermsCondition = async () => {
        setLoading(true);
        setError(null);
        try {
            const result = await fetchWithFormDataWithoutBody('getTermsCondition');
            if (result?.status === true && result?.data) {
                setTcData(result.data);
            } else {
                setError(result?.message || 'Failed to load Terms & Conditions data.');
            }
        } catch (err) {
            console.error('Error fetching Terms & Conditions:', err);
            setError('Something went wrong while fetching Terms & Conditions.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="relative flex justify-center items-center px-16 py-12 bg-white max-md:px-5 min-h-[400px]">
            <div className="absolute bottom-0 pointer-events-none">
                <img
                    src={Images.user_auth_vector}
                    alt="Background Vector"
                    loading="lazy"
                    className="object-fill full-size"
                />
            </div>
            <div className="text-start z-10 mt-6 max-w-full w-[1296px]">
                {loading ? (
                    <Loader />
                ) : error ? (
                    <div className="text-center py-10 text-red-500 font-medium text-lg">
                        {error}
                    </div>
                ) : tcData?.description ? (
                    // <div
                    //     className="dynamic-content flex flex-col self-stretch text-lg blog_intro text-zinc-600 max-md:max-w-full"
                    //     dangerouslySetInnerHTML={{ __html: tcData.description }}
                    // />
                    <div
                        className="dynamic-content flex flex-col self-stretch text-lg blog_intro text-zinc-600 max-md:max-w-full
                        [&_ul]:list-disc
                        [&_ul]:pl-6
                        [&_li]:mb-2"
                        dangerouslySetInnerHTML={{ __html: tcData.description }}
                    />
                ) : (
                    <div className="text-center py-10 text-zinc-500 text-lg">
                        No Terms and Conditions available.
                    </div>
                )}
            </div>
        </div>
    );
};

export default TCContentDynamic;
